<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametreHedefTanim from "@/models/StrPerfTablolarDetayParametreHedefTanim";

export default {
  mixins: [Api, Sabit, StrPerfTablolarDetayParametreHedefTanim],
  props: ["Ustid", "Guncelle"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdateAlt: null,
      Gosterge: null,
       siralama:"&Asc=SiraNo",
    };
  },
  component: {
  },

  watch: {
    Guncelle() {
      this.Get();
    },
  },

  methods: {
    veri_gonder(Data) {
      this.$emit("Ustidvar", Data);


    },

    Get() {

      let Filter = "&Ustid=" + this.Ustid + "&UstidDoluMu=true";
      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreHedefTanim", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data.sort((a, b) => a.Sira - b.Sira);
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
  created() {
    this.Get();
  },
};
</script>
<template>
  <div>

    <table class="table table-striped table-bordered mb-0">
      <thead>
        <tr>
          <th style="width: 85px;" scope="col-2">Sıra No<i style="margin-left:10px" class="bx bx-sort-a-z fa-xl"></i></th>
          <th scope="col">Başlık</th>
          <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrPerfTablolarDetay.Table.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="AltBaslik in TableData" :key="AltBaslik.Id">
          <td style="text-align: center;">{{ AltBaslik.Sira }}</td>
          <td>{{ AltBaslik.Hedefadi }}</td>

          <td style="width: 85px; text-align: center; vertical-align: middle;">

            <b-button-group>
                <b-button variant="success" v-b-modal.StrPerfTablolarDetayParametreHedefTanim 
                @click="veri_gonder(AltBaslik) ">
                <i class="fas fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrPerfTablolarDetayParametreHedefTanim', AltBaslik.Id)"><i class="fas fa-trash-alt"></i></b-button>
            </b-button-group>
            
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
